import React from 'react'
import { Hero } from '@/components/Hero'
import { Services, HowItWorks, ServiceArea, Testimonials } from '@/components/Sections'
import { Scheduler } from '@/components/Scheduler'
import { Membership, Rules, Footer } from '@/components/FooterAndExtras'
import { useLang } from '@/lib/lang'

export function Landing() {
  const { lang, setLang, t } = useLang()

  return (
    <>
      <Hero variant="A" logoVariant="default" t={t} lang={lang} setLang={setLang} />
      <Services emphasis="all" t={t} />
      <HowItWorks t={t} />
      <ServiceArea t={t} />
      <Scheduler paymentModel="deposit" t={t} />
      <Testimonials t={t} />
      <Membership t={t} />
      <Rules t={t} />
      <Footer t={t} />
    </>
  )
}
